// import { makeStyles } from "@mui/styles";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  buttonContainer: () => ({
    display: "flex",
    flexWrap: "wrap",
    // gap: "5px",
    justifyContent: "left",
    paddingTop: "4px",
    height: "100%",
    width: "110%",
    "& .MuiButtonBase-root": {
      fontSize: "12px",
      background: "#EFEEED",
      color: " #4795DE",
      borderRadius: "15px",
      padding: "4px 8px",
      "&:hover": {
        fontSize: "12px",
        background: "#EFEEED",
        color: "#4795DE",
        borderRadius: "15px",
        padding: "4px 8px",
      },
    },
  }),
  defaultButton: () => ({
    marginRight: "5px",
    flexShrink: 0,
  }),
  defaultImageButton: () => ({
    "& .MuiButtonBase-root": {
      fontSize: "12px",
      background: "#EFEEED",
      color: " #4795DE",
      borderRadius: "15px",
      padding: "10px 20px",
      minWidth: "30px",
      "&:hover": {
        fontSize: "12px",
        background: "#EFEEED",
        color: "#4795DE",
        borderRadius: "15px",
        padding: "10px 20px",
      },
    },
  }),
});

export default useStyles;
